var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 10.7626H8C8.26522 10.7626 8.51957 10.6572 8.70711 10.4697C8.89464 10.2821 9 10.0278 9 9.76257C9 9.49736 8.89464 9.243 8.70711 9.05547C8.51957 8.86793 8.26522 8.76257 8 8.76257H5C4.73478 8.76257 4.48043 8.86793 4.29289 9.05547C4.10536 9.243 4 9.49736 4 9.76257C4 10.0278 4.10536 10.2821 4.29289 10.4697C4.48043 10.6572 4.73478 10.7626 5 10.7626ZM17 0.762573H3C2.20435 0.762573 1.44129 1.07864 0.87868 1.64125C0.316071 2.20386 0 2.96692 0 3.76257V12.7626C0 13.5582 0.316071 14.3213 0.87868 14.8839C1.44129 15.4465 2.20435 15.7626 3 15.7626H17C17.7956 15.7626 18.5587 15.4465 19.1213 14.8839C19.6839 14.3213 20 13.5582 20 12.7626V3.76257C20 2.96692 19.6839 2.20386 19.1213 1.64125C18.5587 1.07864 17.7956 0.762573 17 0.762573ZM18 12.7626C18 13.0278 17.8946 13.2821 17.7071 13.4697C17.5196 13.6572 17.2652 13.7626 17 13.7626H3C2.73478 13.7626 2.48043 13.6572 2.29289 13.4697C2.10536 13.2821 2 13.0278 2 12.7626V6.76257H18V12.7626ZM18 4.76257H2V3.76257C2 3.49736 2.10536 3.243 2.29289 3.05547C2.48043 2.86793 2.73478 2.76257 3 2.76257H17C17.2652 2.76257 17.5196 2.86793 17.7071 3.05547C17.8946 3.243 18 3.49736 18 3.76257V4.76257Z",
    fill: "#4B4B4B"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard);
export default __webpack_public_path__ + "static/media/card.c836c26da5661c79c7590ca5fba26e5b.svg";
export { ForwardRef as ReactComponent };